<template>
  <div>
    <order-input :order="order" v-model="shoppingCard"></order-input>
  </div>
</template>

<script>
import OrderInput from "./../../components/order/input/Input";
import { mapGetters } from "vuex";

export default {
  name: "Orders.vue",
  data() {
    return {
      shoppingCard: [],
      order: null,
    };
  },
  components: {
    OrderInput,
  },
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
  created() {
    const userOrder = JSON.parse(unescape(atob(this.$route.params.info)));

    const orderItems = userOrder.items.flatMap((order) =>
      Array(order.quantity).fill(order)
    );

    this.shoppingCard = orderItems;
    this.order = userOrder;
  },
};
</script>

<style scoped lang="scss">
</style>
